import React, { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import { IGif } from "services/types";
import { TileItem } from "./TileItem";
import { routes } from "routes";
import { ViewRegion } from "utils/metrics";

import "./TileFeed.scss";

interface IProps {
  gifs: IGif[];
  hasMore: boolean;
  fetchMore: () => void;
  manage: boolean;
  onSelect?: (ids: string[]) => void;
  injector?: (pos: number, gif: IGif, fullScreen: boolean) => JSX.Element;
  source: ViewRegion;
  rel?: string;
  order: string;
  verified?: boolean;
}

export const TileFeed = (props: IProps) => {
  const [selected, setSelected] = useState<string[]>([]);

  const onCheck = (id: string) => (checked: boolean): void => {
    const values = [...selected];
    const idx = values.indexOf(id);

    if (idx >= 0) {
      values.splice(idx, 1);
    } else {
      values.push(id);
    }

    setSelected(values);

    if (props.onSelect) {
      props.onSelect(values);
    }
  };

  const isChecked = (id: string): boolean => {
    return selected.indexOf(id) >= 0;
  };

  return (
    <InfiniteScroll
      dataLength={props.gifs.length}
      hasMore={props.hasMore}
      next={props.fetchMore}
      loader={<></>}
    >
      <div className="tileFeed">
        {props.gifs.map((gif: IGif, index) => (
          <React.Fragment key={gif.id}>
            <TileItem
              thumbnail={gif.urls.poster}
              video={gif.type === 1 ? gif.urls.sd : undefined}
              published={gif.published}
              verified={gif.verified}
              link={routes.watch(gif.id, props.rel, props.source, props.order, props.verified)}
              views={gif.views}
              duration={gif.duration}
              gallery={!!gif.gallery}
              manage={props.manage}
              checked={isChecked(gif.id)}
              onCheck={onCheck(gif.id)}
              source={props.source}
              index={index}
            />

            {props.injector && props.injector(index, gif, false)}
          </React.Fragment>
        ))}
      </div>
    </InfiniteScroll>
  );
};
